import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Phone, Clock } from "lucide-react";
import { CONTACT_ADDRESS, CONTACT_PHONE, CONTACT_WHATSAPP, CONTACT_HOURS } from "@shared/const";
import { useState } from 'react';

export default function Contato() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    console.log('Form submitted!');
    e.preventDefault();
    setFormStatus('loading');
    const formData = new FormData(e.currentTarget);
    const nome = formData.get('nome') as string;
    const telefone = formData.get('telefone') as string;
    const email = formData.get('email') as string;
    const assunto = formData.get('assunto') as string;
    const mensagem = formData.get('mensagem') as string;
    
    console.log('Enviando dados:', { nome, telefone, email, assunto, mensagem });
    
    try {
      const response = await fetch('https://formspree.io/f/mgvpwebb', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          nome,
          telefone,
          email,
          assunto,
          mensagem,
          _replyto: email,
        }),
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok) {
        setFormStatus('success');
        setFormMessage('Mensagem enviada com sucesso!');
        // Reset form
        if (e.currentTarget) {
          e.currentTarget.reset();
        }
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        setFormStatus('error');
        setFormMessage('Erro ao enviar mensagem. Tente novamente.');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch (error) {
      console.error('Erro:', error);
      setFormStatus('error');
      setFormMessage('Erro ao enviar mensagem. Tente novamente.');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="relative text-primary-foreground h-[265px] flex items-center" style={{backgroundImage: "url('/images/pages/hero-verde.webp')", backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '0 0 96px 0', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)'}}>
          <div className="absolute inset-0" style={{background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0) 100%)"}}></div>
          <div className="container relative z-10">
            <h1 className="text-5xl md:text-7xl font-serif text-center" style={{fontFamily: "'Suez One', serif"}}>
              Contato
            </h1>
          </div>
        </section>

        {/* Informações de Contato */}
        <section className="py-16 md:py-24 bg-background">
          <div className="container">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {/* Endereço - Card Esquerdo com arredondamento */}
              <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 transition-all duration-300 hover:scale-105 hover:shadow-lg" style={{borderRadius: '8px 58px 8px 8px', backgroundColor: 'rgba(211, 214, 85, 0.3)', border: '2px solid #D3D655'}}>
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" style={{backgroundColor: '#D3D655'}}>
                    <MapPin className="w-8 h-8" style={{color: '#003B4A'}} />
                  </div>
                  <h3 className="text-xl font-semibold mb-3" style={{color: '#003B4A'}}>
                    Endereço
                  </h3>
                  <p style={{color: '#003B4A'}}>
                    {CONTACT_ADDRESS}
                  </p>
                </CardContent>
              </Card>

              {/* WhatsApp - Card Central */}
              <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 transition-all duration-300 hover:scale-105 hover:shadow-lg" style={{backgroundColor: 'rgba(0, 59, 74, 0.3)', borderRadius: '8px', border: '2px solid #003B4A'}}>
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" style={{backgroundColor: '#003B4A'}}>
                    <Phone className="w-8 h-8" style={{color: '#f2f2f2'}} />
                  </div>
                  <h3 className="text-xl font-semibold mb-3" style={{color: '#003B4A'}}>
                    WhatsApp
                  </h3>
                  <a 
                    href={CONTACT_WHATSAPP}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color: '#003B4A'}} className="hover:underline"
                  >
                    {CONTACT_PHONE}
                  </a>
                </CardContent>
              </Card>

              {/* Horários - Card Direito com arredondamento */}
              <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 transition-all duration-300 hover:scale-105 hover:shadow-lg" style={{borderRadius: '58px 8px 8px 8px', backgroundColor: 'rgba(159, 207, 202, 0.3)', border: '2px solid #9FCFCA'}}>
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" style={{backgroundColor: '#9FCFCA'}}>
                    <Clock className="w-8 h-8" style={{color: '#003B4A'}} />
                  </div>
                  <h3 className="text-xl font-semibold mb-3" style={{color: '#003B4A'}}>
                    Horários
                  </h3>
                  <p style={{color: '#003B4A'}}>
                    {CONTACT_HOURS}
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Formulário com Imagem */}
            <div className="mt-16">
              <div className="text-center mb-12">
                <h2 className="text-4xl md:text-6xl font-serif mb-4 text-primary" style={{fontFamily: "'Suez One', serif"}}>
                  Tem alguma dúvida?
                </h2>
                <p className="text-base md:text-lg text-muted-foreground" style={{lineHeight: "1.4"}}>
                  Preencha o formulário abaixo e entraremos em contato o mais breve possível.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                {/* Imagem na Esquerda */}
                <div className="flex justify-center">
                  <img loading="lazy" 
                    src="/images/pages/contato-imagem.png" 
                    alt="Parceria Fercci"
                    className="w-full h-full rounded-lg object-cover"
                  />
                </div>

                {/* Formulário na Direita */}
                <div>
                  <Card className="border-0">
                    <CardContent className="p-8">
                      {formStatus === 'success' && (
                        <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
                          {formMessage}
                        </div>
                      )}
                      {formStatus === 'error' && (
                        <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg">
                          {formMessage}
                        </div>
                      )}
                      <form onSubmit={handleFormSubmit} className="space-y-4">
                        <div>
                          <label htmlFor="nome" className="block text-sm font-medium mb-2">
                            Nome *
                          </label>
                          <input
                            id="nome"
                            name="nome"
                            type="text"
                            placeholder="Seu nome completo"
                            className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                            required
                          />
                        </div>

                        <div>
                          <label htmlFor="telefone" className="block text-sm font-medium mb-2">
                            Telefone *
                          </label>
                          <input
                            id="telefone"
                            name="telefone"
                            type="tel"
                            placeholder="(00) 00000-0000"
                            className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                            required
                          />
                        </div>

                        <div>
                          <label htmlFor="email" className="block text-sm font-medium mb-2">
                            E-mail *
                          </label>
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="seu@email.com"
                            className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                            required
                          />
                        </div>

                        <div>
                          <label htmlFor="assunto" className="block text-sm font-medium mb-2">
                            Assunto *
                          </label>
                          <input
                            id="assunto"
                            name="assunto"
                            type="text"
                            placeholder="Assunto da mensagem"
                            className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                            required
                          />
                        </div>

                        <div>
                          <label htmlFor="mensagem" className="block text-sm font-medium mb-2">
                            Mensagem *
                          </label>
                          <textarea
                            id="mensagem"
                            name="mensagem"
                            placeholder="Nos conte como podemos te ajudar!"
                            rows={6}
                            className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                            required
                          />
                        </div>

                        <button 
                          type="submit"
                          disabled={formStatus === 'loading'}
                          className="w-full bg-accent hover:bg-accent/90 text-primary font-semibold py-3 rounded-md uppercase transition-colors disabled:opacity-50"
                         
                        >
                          {formStatus === 'loading' ? 'ENVIANDO...' : 'ENVIAR'}
                        </button>
                      </form>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

